// Periode Cuti peserta (Okt 2026) -- cermin aturan backend periode_cuti.py (periksa_periode_cuti). Server tetap
// penentu (422 dgn pesan yg sama); di sini hanya pemeriksaan awal supaya galat tampil sebelum menyimpan.
// Tanggal berformat YYYY-MM-DD (input type="date"), jadi perbandingan teks = urutan tanggal.
export const MAKS_PERIODE_CUTI = 10;
export const TAHUN_MIN_CUTI = 2020;
export const TAHUN_MAKS_SETELAH_BERJALAN = 2;

const POLA_TANGGAL = /^\d{4}-\d{2}-\d{2}$/;
const tanggalSah = (t) => POLA_TANGGAL.test(t || "") && !Number.isNaN(Date.parse(`${t}T00:00:00Z`))
    && new Date(`${t}T00:00:00Z`).toISOString().slice(0, 10) === t;
const formatHariBulanTahun = (t) => `${t.slice(8, 10)}-${t.slice(5, 7)}-${t.slice(0, 4)}`;

// Pesan galat pertama (teks sama dgn backend) atau null bila sah.
export function periksaPeriodeCuti(daftar, tahunBerjalan) {
    if (daftar.length > MAKS_PERIODE_CUTI) return `Periode cuti paling banyak ${MAKS_PERIODE_CUTI}.`;
    const tahunMaks = tahunBerjalan + TAHUN_MAKS_SETELAH_BERJALAN;
    for (let i = 0; i < daftar.length; i += 1) {
        const { mulai, akhir } = daftar[i];
        if (!tanggalSah(mulai) || !tanggalSah(akhir)) {
            return `Periode cuti ke-${i + 1}: tanggal mulai dan akhir wajib diisi dengan format TTTT-BB-HH.`;
        }
        if (mulai > akhir) return `Periode cuti ke-${i + 1}: tanggal mulai tidak boleh setelah tanggal akhir.`;
        if (Number(mulai.slice(0, 4)) < TAHUN_MIN_CUTI || Number(akhir.slice(0, 4)) > tahunMaks) {
            return `Periode cuti ke-${i + 1}: tahun harus antara ${TAHUN_MIN_CUTI} dan ${tahunMaks}.`;
        }
    }
    const urut = urutkanPeriode(daftar);
    for (let i = 1; i < urut.length; i += 1) {
        const a = urut[i - 1];
        const b = urut[i];
        if (b.mulai <= a.akhir) {
            return `Periode cuti ${formatHariBulanTahun(a.mulai)} s/d ${formatHariBulanTahun(a.akhir)} dan `
                + `${formatHariBulanTahun(b.mulai)} s/d ${formatHariBulanTahun(b.akhir)} tumpang tindih.`;
        }
    }
    return null;
}

// Salinan baru terurut tanggal mulai (tidak mengubah daftar asal).
export const urutkanPeriode = (daftar) => [...daftar].sort((a, b) => (a.mulai < b.mulai ? -1 : a.mulai > b.mulai ? 1 : 0));

export const samaPeriode = (a, b) => JSON.stringify(urutkanPeriode(a)) === JSON.stringify(urutkanPeriode(b));

// Tahun berjalan menurut WIB (UTC+7, sama dgn now_wib() server) -- batas tahun maksimum periode cuti.
const SELISIH_WIB_MS = 7 * 60 * 60 * 1000;
export const tahunBerjalanWIB = (sekarang = Date.now()) => new Date(sekarang + SELISIH_WIB_MS).getUTCFullYear();
